import { createStructuredSelector } from 'reselect'

import {
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST,
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST_SUCCESS, 
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_PAGE_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_CHANGE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_CHANGE,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_CHANGE,
  EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'equipment_stock_detail_item';

export const EquipmentStockDetailItemList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EquipmentStockDetailItemListSuccess = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_LIST_SUCCESS,
  payload: data
});

export const EquipmentStockDetailItemListError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_LIST_ERROR,
  payload: error
});

export const EquipmentStockDetailItemPageSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_PAGE_SET,
  payload: data
});

export const EquipmentStockDetailItemSearchSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SET,
  payload: data
});

export const EquipmentStockDetailItemSearchChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_CHANGE,
  payload: data
});

export const EquipmentStockDetailItemSearchEquipmentStockDetail = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL,
  payload: data
});

export const EquipmentStockDetailItemSearchEquipmentStockDetailSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchEquipmentStockDetailError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemSearchOperationStatus = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS,
  payload: data
});

export const EquipmentStockDetailItemSearchOperationStatusSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchOperationStatusError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemSearchApplyOption = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION,
  payload: data
});

export const EquipmentStockDetailItemSearchApplyOptionSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchApplyOptionError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemSearchEquipmentFile = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE,
  payload: data
});

export const EquipmentStockDetailItemSearchEquipmentFileSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchEquipmentFileError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemSearchAcquisitionMode = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE,
  payload: data
});

export const EquipmentStockDetailItemSearchAcquisitionModeSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchAcquisitionModeError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemSearchInstallationCondition = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION,
  payload: data
});

export const EquipmentStockDetailItemSearchInstallationConditionSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchInstallationConditionError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemSearchServiceType = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE,
  payload: data
});

export const EquipmentStockDetailItemSearchServiceTypeSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemSearchServiceTypeError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_ERROR,
  payload: error
}); 

export const EquipmentStockDetailItemAddChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_ADD_CHANGE,
  payload: data
});

export const EquipmentStockDetailItemAddSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SET,
  payload: data
});

export const EquipmentStockDetailItemAddModalSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_ADD_MODAL_SET,
  payload: data
});

export const EquipmentStockDetailItemAdd = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_ADD,
  payload: data
});

export const EquipmentStockDetailItemAddSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SUCCESS,
  payload: message
});

export const EquipmentStockDetailItemAddError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_ADD_ERROR,
  payload: error
});

export const EquipmentStockDetailItemDetail = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL,
  payload: data
});

export const EquipmentStockDetailItemDetailSuccess = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_SUCCESS,
  payload: data
});

export const EquipmentStockDetailItemDetailError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_ERROR,
  payload: error
});

export const EquipmentStockDetailItemViewModalSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_MODAL_SET,
  payload: data
});

export const EquipmentStockDetailItemEditModalSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_MODAL_SET,
  payload: data
});

export const EquipmentStockDetailItemEditChangeSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_CHANGE,
  payload: data
});

export const EquipmentStockDetailItemUpdate = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE,
  payload: data
});

export const EquipmentStockDetailItemUpdateSuccess = (message) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_SUCCESS,
  payload: message.message
});

export const EquipmentStockDetailItemUpdateError = (error) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_ERROR,
  payload: error
});

export const EquipmentStockDetailItemViewTabSet = (data) => ({
  type: EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_TAB_SET,
  payload: data
});

const equipment_stock_detail_item = (state) => state[NAME];

export const EquipmentStockDetailItemSelector = createStructuredSelector({
  equipment_stock_detail_item
})
 